export const highlightWarnings = {
  computed: {
    highlightSwalOptions() {
      return {
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        width: '38em',
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: 'primary-color margin-left-btn v-btn v-btn--contained v-size--default primary',
          cancelButton: 'v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light v-size--default primary--text',
        },
      }
    },
  },
  methods: {
    highlightFinishWarning(status) {
      return {
        title: 'Finalizar campanha',
        message: `Ao finalizar uma campanha de trade, não será possível ativá-la novamente. A campanha será movida para o status ${status}.`,
        confirmText: 'Ok',
        cancelText: 'Cancelar',
      }
    },
  },
}
